// extracted by mini-css-extract-plugin
export default {"videoContainer":"BaseInfoModal_videoContainer__nhdim","actions":"BaseInfoModal_actions__A9Hpf","videoDescription":"BaseInfoModal_videoDescription__GpNKS"};